import type { Campaign, CampaignStatus } from '@/lib/campaigns'

export const INSTITUTION_CAMPAIGN_STATUS_LABELS: Record<CampaignStatus, string> = {
  draft: 'Rascunho',
  active: 'Ativa',
  finished: 'Finalizada',
  cancelled: 'Cancelada',
}

export function campaignToSelectOption(c: Campaign): {
  value: string
  label: string
  subtitle: string | undefined
} {
  const label = c.title?.trim() || c.name || 'Campanha'
  const subtitle =
    c.status && INSTITUTION_CAMPAIGN_STATUS_LABELS[c.status]
      ? INSTITUTION_CAMPAIGN_STATUS_LABELS[c.status]
      : undefined
  return {
    value: String(c.id),
    label,
    subtitle,
  }
}
